<template>
  <v-dialog :value="isActive" @click:outside="closeDialog()" max-width="600" scrollable>
    <ValidationObserver v-slot="{ handleSubmit }">
      <v-card :loading="isLoading">
        <v-card-title class="pa-0 shadow-1">
          <v-img
            :src="require('@/assets/illustrations/bg_modal_card.svg')"
            cover
            position="left bottom"
            class="align-center"
            height="65px"
          >
            <v-card-title class="font-weight-medium primary--text">
              {{ isEditMode ? "Actualizar" : "Crear" }} Contacto
            </v-card-title>
          </v-img>
        </v-card-title>

        <vuescroll
          :ops="{
            bar: { background: '#bacfcec0', keepShow: true },
          }"
        >
          <v-card-text :style="`max-height: ${DIALOG_MAX_HEIGHT}`">
            <v-row>
              <!-- Nombre -->
              <v-col cols="12" class="pb-0">
                <ValidationProvider name="Nombre" rules="required" v-slot="{ errors }">
                  <v-text-field
                    v-model="payload.name"
                    :error-messages="errors"
                    prepend-inner-icon="mdi-format-title"
                    label="Nombre"
                    rounded
                    filled
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
              <!-- URL -->
              <v-col cols="12" class="py-0">
                <ValidationProvider name="URL" rules="required" v-slot="{ errors }">
                  <v-text-field
                    v-model="payload.url"
                    :error-messages="errors"
                    label="URL"
                    prepend-inner-icon="mdi-link"
                    rounded
                    filled
                  >
                  </v-text-field>
                </ValidationProvider>
              </v-col>
              <!-- API -->
              <v-col cols="12" class="py-0">
                <ValidationProvider name="API" v-slot="{ errors }">
                  <v-text-field
                    v-model="payload.api"
                    :error-messages="errors"
                    label="API"
                    prepend-inner-icon="mdi-api"
                    rounded
                    filled
                  >
                  </v-text-field>
                </ValidationProvider>
              </v-col>
              <!-- Usuario -->
              <v-col cols="12" class="py-0">
                <v-text-field
                  v-model="payload.user"
                  label="Usuario"
                  prepend-inner-icon="mdi-account"
                  rounded
                  filled
                ></v-text-field>
              </v-col>
              <!-- Clave -->
              <v-col cols="12" class="py-0">
                <v-text-field
                  v-model="payload.password"
                  label="Clave"
                  prepend-inner-icon="mdi-lock"
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="showPassword ? 'text' : 'password'"
                  @click:append="showPassword = !showPassword"
                  rounded
                  filled
                ></v-text-field>
              </v-col>
              <!-- Client all -->
              <v-col cols="12" class="py-0 px-7">
                <v-checkbox v-model="payload.client_all" label="Para todos"></v-checkbox>
              </v-col>
              <!-- Local -->
              <v-col cols="12" class="py-0 px-7">
                <v-checkbox v-model="payload.local" label="Uso local"></v-checkbox>
              </v-col>
              <!-- WhatsApp -->
              <v-col cols="12" class="py-0 px-7">
                <v-checkbox v-model="payload.whatsapp" label="WhatsApp"></v-checkbox>
              </v-col>

              <!-- Línea WhatsApp  -->
              <v-col cols="12" class="py-0" v-if="payload.whatsapp">
                <ValidationProvider name="línea de WhatsApp" rules="required|integer" v-slot="{ errors }">
                  <v-text-field
                    v-model="payload.whatsapp_line"
                    :error-messages="errors"
                    label="Línea WhatsApp"
                    rounded
                    filled
                    required
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
              <!-- Tipo de mensaje  -->
              <v-col cols="12" class="py-0" v-if="payload.whatsapp">
                <ValidationProvider name="tipo de mensaje" rules="required|integer" v-slot="{ errors }">
                  <v-text-field
                    v-model="payload.whatsapp_type"
                    :error-messages="errors"
                    label="Tipo de mensaje"
                    rounded
                    filled
                    required
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
            </v-row>
          </v-card-text>
        </vuescroll>
        <v-card-actions>
          <v-btn @click="closeDialog()" class="px-8" color="error" rounded large text>
            Cerrar
          </v-btn>
          <v-spacer></v-spacer>

          <v-btn @click="handleSubmit(submitForm)" :disabled="isLoading" class="px-8" color="success" rounded large>
            {{ isEditMode ? "Actualizar" : "Crear" }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </ValidationObserver>
  </v-dialog>
</template>

<script>
import vuescroll from "vuescroll";
import { PbxHttpClient } from "@/services/httpclient";
import { DIALOG_MAX_HEIGHT } from "@/utils";

export default {
  props: {
    isActive: {
      type: Boolean,
    },
    isEditMode: {
      type: Boolean,
      default: false,
    },
    dataToEdit: {
      type: Object,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: {},
    },
  },
  components: { vuescroll },

  data() {
    return {
      DIALOG_MAX_HEIGHT,
      payload: {
        name: "",
        url: "",
        api: "",
        user: "",
        password: "",
        client_all: false,
        local: false,
      },
      showPassword: false,
      isLoading: false,
    };
  },

  created() {
    this.payload = { ...this.dataToEdit };
  },

  methods: {
    async submitForm() {
      this.isLoading = true;
      try {
        const { id, ...payload } = this.payload;
        const { data } = this.isEditMode
          ? await PbxHttpClient.put(`/gateway/${id}`, payload)
          : await PbxHttpClient.post("/gateway", payload);

        this.closeDialog(data);
        this.$snotify.success("Gateway creado con exito", "¡Hecho!");
      } catch (err) {
        // console.log(err);
        this.$snotify.error("No se pudo guardar los cambios", "¡Error!");
      }

      this.isLoading = false;
    },
    closeDialog(data = false) {
      this.$emit("close:dialog", data);
    },
  },
};
</script>

<style></style>
